'use client'

import { UserAvatarDropdown } from '~/components/user-avatar-dropdown'
import { Actions } from './actions'
import { useUserStore } from '~/app/_store/user-store'

export const UserNav = ({ themeSwitcher }: { themeSwitcher: boolean }) => {
  const { optimisticUser, isLoading, isSigningOut } = useUserStore()

  return (
    <div
      className="flex items-center space-x-2 transition-opacity pointer-events-none select-none justify-self-end"
      style={{ opacity: !isLoading ? 1 : 0 }}
    >
      {isSigningOut ? (
        <p className="text-xs text-dark-muted">Signing out...</p>
      ) : (
        <>
          <Actions />
          {optimisticUser && (
            <div className="pointer-events-auto">
              <UserAvatarDropdown isSignedIn themeSwitcher={themeSwitcher} />
            </div>
          )}
        </>
      )}
    </div>
  )
}
